<template>
    <v-layout row>
      <v-flex xs12 mb-6>
        <v-list v-if="allTemplates">
          <template v-for="template in allTemplates.nodes">
            <v-list-tile
              :key="template.title"
              avatar
              @click="goToNewEvaluation(template.id)"
            >
            <v-list-tile-content>
                <v-list-tile-title v-html="template.title"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn flat small color="primary">{{$t('newEvaluation')}} <v-icon>chevron_right</v-icon></v-btn>
            </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <div v-if="allTemplates && allTemplates.nodes.length === 0">
          <p class="grey--text px-3">
            {{$t('templateListEmpty')}}
          </p>
        </div>
      </v-flex>
    </v-layout>
</template>



<script>
import { allTemplateTitles } from '@/graphql/templateQueries.gql'
//import { allTemplateTitles, ... , ... } from '@/graphql/templateQueries.gql'


export default {
  apollo: {
      allTemplates: allTemplateTitles
  },
  data() { return {
      allTemplatesList: null
  }},
  methods: {
    goToNewEvaluation (clickedTemplateId) {
      this.$router.push({ name: 'newEvaluation', params: {templateId: clickedTemplateId}}) //params: ... 
    }
  }
}
</script>